module.exports = global["swal"] = require("-!./sweetalert.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?swal!./sweetalert.js
// module id = 9
// module chunks = 0